import axios from "axios";

export const state = {
    cartItems: [],
};

export const getters = {
    cartItems: state => state.cartItems,
};

export const mutations = {
    setSalesCarts(state, newValue) {
        state.cartItems = newValue
    },
};

export const actions = {
    fetchSalesCarts({ commit }) {
        axios.get('/cartItems').then(res => {
            commit('setSalesCarts', res.data.cartItems);
        })
    },
};
